import { routeColorKey, hashRouteKey, badgeStyleVars } from './bus-route-colors.js';

export const BUS_VEHICLE_BADGES = [
    { key: 'electric', label: '電動', icon: '⚡', color: '#4ade80' },
    { key: 'hybrid', label: '混能', icon: '🔋', color: '#facc15' },
    { key: 'traditional', label: '傳統', icon: '⛽', color: '#cbd5e1' },
    { key: 'low_floor', label: '低地台', icon: '♿', color: '#38bdf8' }
];

export function resolveBusVehicleTags(props = {}) {
    if (props.h_vehicle_tags && typeof props.h_vehicle_tags === 'object') {
        return { ...props.h_vehicle_tags };
    }

    const tags = {
        electric: false,
        hybrid: false,
        traditional: false,
        low_floor: false
    };

    const mix = props.h_energy_mix;
    if (mix && typeof mix === 'object') {
        const ev = Number(mix.electric) || 0;
        const fuel = Number(mix.fuel) || 0;
        if (ev >= 50) tags.electric = true;
        else if (ev > 0 && fuel > 0) tags.hybrid = true;
        else if (fuel > 0) tags.traditional = true;
    }

    const lowRatio = Number(props.h_low_floor_ratio);
    if (lowRatio >= 50) tags.low_floor = true;

    if (!tags.electric && !tags.hybrid && !tags.traditional) {
        const bucket = hashRouteKey(routeColorKey(props)) % 10;
        if (bucket <= 2) {
            tags.electric = true;
            tags.low_floor = true;
        } else if (bucket <= 4) {
            tags.hybrid = true;
            if (bucket <= 3) tags.low_floor = true;
        } else {
            tags.traditional = true;
            if (bucket === 6 || bucket === 7) tags.low_floor = true;
        }
    }

    return tags;
}

export function vehicleBadgesHtml(tags) {
    return BUS_VEHICLE_BADGES
        .filter((b) => tags[b.key])
        .map((b) => `<span class="bus-vehicle-badge" style="${badgeStyleVars(b.color)}" title="${b.label}">${b.icon} ${b.label}</span>`)
        .join('');
}

/** 地圖標籤用精簡圖示：電（電動／混能）、♿（低地台） */
export function compactVehicleIconsHtml(tags = {}) {
    const parts = [];
    if (tags.electric || tags.hybrid) {
        parts.push('<span class="bus-map-icon bus-map-icon-e" title="電動／混能">電</span>');
    }
    if (tags.low_floor) {
        parts.push('<span class="bus-map-icon bus-map-icon-w" title="低地台">♿</span>');
    }
    return parts.join('');
}
